import React, { Fragment, useState } from 'react';

import Loader from 'components/Loader';
import PageHelmet from 'components/common/Helmet';
import Footer from 'components/footer/Footer';
import Header from 'components/header/Header';
import { Title } from 'components/title/Title';
import { Field, Form, Formik } from 'formik';
import { useHistory } from 'react-router';
import { addPasswordSchema } from 'utils/validationSchemas';

export const PasswordChange = (props) => {
	const { firebase } = props;

	const [loading, setLoading] = useState(false)
	const [error, setError] = useState({})

	const history = useHistory()

	const handlePasswordChange = (values, actions) => {
		setLoading(true)
		firebase
			.passwordUpdate(values.password)
			.then(() => {
				history.push('/login')
				setLoading(false)
				actions.setSubmitting(false)
			})
			.catch(err => {
				setError(err);
				setLoading(false)
				actions.setSubmitting(false)
			})
	}

	return (
		<Fragment>
			<PageHelmet pageTitle='Forgot Password' />

			<Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

			<Title title='Forgot Password' />

			<div className="contact-form--1 pt--50 pb--50">
				<div className="container">
					<div className="row row--35 align-items-center justify-content-center">
						<div className="col-lg-6">
							<div className="section-title text-center mb--50">
								<h2 className="title">Change Password</h2>
							</div>
							<Formik
								initialValues= {{
									email: ''
								}}
								validationSchema= {addPasswordSchema}
								onSubmit={handlePasswordChange}
							>
								{({ errors, getFieldProps, handleSubmit, isSubmitting, touched }) => (
									<div className="form-wrapper">
										{ loading
											? <Loader />
											: (
												<div>

													<Form onSubmit={handleSubmit}>

														{touched.password && errors.password ? (<div className="error">{errors.password}</div>) : null}
														<Field required icon='lock' id="password" type="password" placeholder="Add Password" {...getFieldProps('password')} />

														{touched.confirmPassword && errors.confirmPassword && (<span className="error">{errors.confirmPassword}</span>)}
														<Field required id="confirmPassword" type="password" placeholder="Confirm New Password" {...getFieldProps('confirmPassword')} />

														{error && <p className="error">{error.message}</p>}

														<button
															className="w-100 rn-button-style--2 btn-solid"
															disabled={isSubmitting}
															type="submit"
															value="submit"
															name="submit"
															id="mc-embedded-subscribe"
														>
															Reset My Password
														</button>

													</Form>
												</div>
											)
										}
									</div>
								)}
							</Formik>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</Fragment>
	)
}

